import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Overlay;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
/* eslint "jsx-a11y/click-events-have-key-events": "warn" */
/* eslint "jsx-a11y/no-static-element-interactions": "warn" */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

/*
 * We might be able to do the mouse over stuff automatically inside of this
 * component but it seems like this is the simplest and best choice for now.
 */

import { jsx, Global } from '@instructure/emotion';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { END_EDITING_TRIGGER_CLASSNAME, withStyleOverrides } from '@instructure/quiz-common';
var Overlay = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Overlay = /*#__PURE__*/function (_Component) {
  function Overlay() {
    _classCallCheck(this, Overlay);
    return _callSuper(this, Overlay, arguments);
  }
  _inherits(Overlay, _Component);
  return _createClass(Overlay, [{
    key: "overlayDiv",
    value: function overlayDiv() {
      if (this.props.hideOverlay) {
        return null;
      }
      var overlayClass = "overlay ".concat(END_EDITING_TRIGGER_CLASSNAME);
      return jsx("div", {
        role: "presentation",
        className: overlayClass,
        css: this.props.styles.overlay,
        onClick: this.props.onClick,
        "data-automation": "sdk-overlay"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        wrapperStyles = _this$props.wrapperStyles,
        children = _this$props.children,
        tabIndex = _this$props.tabIndex,
        ariaLabel = _this$props.ariaLabel;
      return jsx(React.Fragment, null, jsx(Global, {
        styles: {
          'body.tox-fullscreen .overlay': {
            zIndex: '0'
          }
        }
      }), jsx("div", {
        css: [this.props.styles.root, wrapperStyles],
        "data-testid": "overlay-wrapper",
        tabIndex: tabIndex,
        "aria-label": ariaLabel
      }, this.overlayDiv(), children));
    }
  }]);
}(Component), _defineProperty(_Overlay, "displayName", 'Overlay'), _defineProperty(_Overlay, "componentId", "Quizzes".concat(_Overlay.displayName)), _defineProperty(_Overlay, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  hideOverlay: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  wrapperStyles: PropTypes.object,
  tabIndex: PropTypes.string,
  ariaLabel: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_Overlay, "defaultProps", {
  hideOverlay: false,
  tabIndex: '0',
  wrapperStyles: {},
  ariaLabel: void 0
}), _Overlay)) || _class);
export default Overlay;